package io.jsonize.web.navigation

sealed class Route{
//    object Home: Route()
    object Editor: Route()
//    object Generator: Route()
    object Settings: Route()
}

